import React, {useEffect, useRef, useState} from 'react'
import IconMail from '../../../../../../components/icon/IconMail'
import IconSendMail from '../../../../../../components/icon/IconSendMail'
import {useFormik} from 'formik'
import IconDevis from '../../../../../../components/icon/iconDevis'
import Swal from 'sweetalert2'
import {toast} from 'react-toastify'
import {
  postEmailPropos,
  postEmailRenvoiPropos,
  postResendDevis,
} from '../../../../../../components/requests'
import {useMatch, useNavigate} from 'react-router-dom'
import 'react-quill/dist/quill.snow.css'
import './../../../../../../../src/_metronic/assets/css/quillCustomized.css'
import ReactQuill from 'react-quill'

const API_URL = process.env.REACT_APP_API_URL
const pot_url = `${API_URL}/photos/POT/`
const piece_jointe_supplementaire_url = `${API_URL}/uploads/pieceJointeSupplemantaire/`

const EmailForm = (props) => {
  const {
    libelleList,
    setHasLibelleChanged,
    dataClientInfos,
    demandeId,
    now,
    dateStr,
    panier,
    pieces,
    setDisableBtn,
    clientId,
    setPanier,
    redirectDemandeListPage,
    redirectToClientDemande,
    demandeClient,
    setDemandeClient,
    setPiecesProps,
    setLoadStock,
    lienBackend,
    loadingPJ,
    fileName,
    setOpenModalDevis,
    otherData,
    // quillRef,
    onResendPropo,
    filters,
    setLoadingRenvoiPropos,
    piecesProposeesModifiees,
    setPiecesProposesModifiees,
    setCheckedPieces,
    piecesProposeesChecked,
    setPiecesProposeesChecked,
    aProposerPanier,
    regenerateDevisPdf,
    displayHistory,
    historiqueDevis,
    activeHistorique,
    setInitialPieces,
    computeSources,
    mailContent,
    onMailContentChange,
    commentaireInterne,
    setCommentaireInterne,
    associations,
    retraitDepot,
    handleDownloadPdf,
    clientContacts,
    pieceJointeSuppl,
    setPieceJointeSuppl,
    updateAdresseLivraison,
    updateAdresseFacturation,
    isAdresseUpdated,
    setUpdatedAdresseLivInfo,
    setUpdatedAdresseFactInfo,
  } = props
  const navigate = useNavigate()
  const [destinataireError, setDestinataireError] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [destinataireCcError, setDestinataireCcError] = useState<boolean>(false)
  const [errorMessageDestinataireCc, setErrorMessageDestinataireCc] = useState<string>('')
  const [demandeKey, setDemandeKey] = useState(0) // Créer un state pour tracker les changements de demande
  const filterPieceAproposee = panier.filter((pan) => pan.statut === 'A_PROPO')
  const filterPieceProposee = panier.filter((pan) => pan.statut === 'PROPO')
  const onListePieceStockPage = useMatch('/demandes/:id/enStock')
  const [devisSource, setDevisSource] = useState<string>('')
  const pieceJointeRef = useRef<any>(null)
  const haveIntervention = !!(demandeClient?.clientDemandeEtape?.code === 'ASSIG' && demandeClient?.intervention)

  // Verification si il y a plus d'une pièce dans le panier correspondant à l'idDemandePiece
  const nonDisponibleEnvoiEmail = (pieces ?? [])
    ?.filter((item) => (item?.statut === "NON_DISPONIBLE" && item?.envoiEmail === false))

  const listeNonDisponibleEnvoiEmail = nonDisponibleEnvoiEmail?.map((item) => {
    const codeCategorie = item?.typePiece?.sousCategorie?.categorie?.code ?? ''
    const codeSousCategorie = item?.typePiece?.sousCategorie?.code ?? ''
    const codePiece = item?.typePiece?.code ?? ''

    const codeNomenclature = item?.typePieceHn !== null ? '999999' : `${codeCategorie}${codeSousCategorie}${codePiece}`
    const nomPiece = item?.typePiece?.nom ?? item?.typePieceHn
    const isVHT = (item?.clientDemandeImmat?.vehiculeHorsType !== null) ? '[VHT]' : ''

    const marqueModele = `${item?.marque} - ${item?.modele} ${isVHT}`

    return `<li>[${codeNomenclature}] - ${nomPiece} pour le véhicule ${marqueModele}</li>`
  })

  const imagesPOT = aProposerPanier.flatMap((item) => item.potObj?.images ?? [])

  useEffect(() => {
    formik.setFieldValue('nomFichier', props.fileName)
  }, [props.fileName])

  useEffect(() => {
    // Quand demandeId change, forcer réinit du message
    if (demandeId) {
      setDemandeKey((prev) => prev + 1)
    }
  }, [demandeId])

  const contenuEmailDevis = `
  <p>Bonjour,</p>
  ${
    onResendPropo
      ? `
        <p>Suite à la négociation de prix que vous avez demandée.</p>
        <p>Nous vous renvoyons le devis contenant la mise à jour des propositions.</p>
      `
      : `
        <p>Veuillez trouver ci-joint notre devis n°DEV-${dateStr}${demandeId} daté du ${now}.</p>
        <p>Ce devis est valable 30 jours à compter de sa date d'émission.</p>
        <p>N'hésitez pas à nous contacter pour toute question ou information complémentaire.</p>
      `
  }
  ${
    nonDisponibleEnvoiEmail?.length > 0
      ? `
        <br/>
        <p>
          Nous vous informons aussi qu'aucune pièce n'est disponible pour ${listeNonDisponibleEnvoiEmail?.length > 1 ? 'les demandes de pièces suivantes' : 'la demande de pièce suivante'} :
        </p>
        ${listeNonDisponibleEnvoiEmail.join('')}
      ` : ''
  }
  <p>Cordialement,<br/>L'équipe commerciale SURPLUS ${devisSource}</p>
`

  const emailDestinataireParDefaut = otherData?.professionnel
    ? otherData?.contactedBy?.email ?? dataClientInfos?.email
    : dataClientInfos?.email

  const emailDestinaitaireCCParDefaut = displayHistory
    ? (historiqueDevis?.[activeHistorique]?.destinataireCc ?? '')
    : clientContacts
      ?.filter((item) => item?.destinataireCc === true && item?.email !== emailDestinataireParDefaut)
      ?.map((item) => item?.email)
      ?.join(' ; ');

  const objetEmailParDefaut = [
    `Devis DEV-${dateStr}${demandeId}`,
    dataClientInfos?.nomSociete?.trim(),
    dataClientInfos?.email?.trim(),
  ]
    .filter(Boolean)
    .join(' - ')

  // Méthode pour retirer la section dans le mail contenant le lien
  const prepareMessageHistory = (message: string) => {
    const firstPart = message?.split('<table')?.[0]?.replace('<p><br></p>', '')
    const lastPart = message
      ?.split('<table')?.[1]
      ?.split('</table>')?.[1]
      ?.replace('<p><br></p>', '')
    return [firstPart, lastPart]?.join('')
  }

  const demandeDevisId = historiqueDevis?.[activeHistorique]?.id
  const destinataire = displayHistory
    ? historiqueDevis?.[activeHistorique]?.destinataire
    : emailDestinataireParDefaut
  const objet = displayHistory ? historiqueDevis?.[activeHistorique]?.objet : objetEmailParDefaut
  const url = displayHistory
    ? `${
        historiqueDevis?.[activeHistorique]?.message?.split('<a href="')?.[1]?.split('">')?.[0]
      }` ?? ''
    : ''
  const message = displayHistory
    ? prepareMessageHistory(historiqueDevis?.[activeHistorique]?.message)
    : contenuEmailDevis
  const nomFichier = displayHistory
    ? historiqueDevis?.[activeHistorique]?.nomFichier
    : props?.fileName

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      destinataire: displayHistory
        ? (historiqueDevis?.[activeHistorique]?.destinataire ?? '')
        : (mailContent?.destinataire || destinataire),
      destinataireCc: displayHistory
        ? (historiqueDevis?.[activeHistorique]?.destinataireCc ?? '')
        : (mailContent?.destinataireCc || emailDestinaitaireCCParDefaut),
      objet: displayHistory
        ? (historiqueDevis?.[activeHistorique]?.objet ?? '')
        : (mailContent?.objet || objet),
      message: mailContent?.message || message,
      nomFichier: nomFichier,
    },
    onSubmit: async (values: any) => {
      if (values.destinataire === '') {
        setDestinataireError(true)
      } else {
        setDestinataireError(false)
        if (displayHistory) {
          handleRenvoiDevis(values)
        } else {
          if (onResendPropo) {
            handleRenvoiPropositionSubmit(values)
          } else {
            handleSubmit(values)
          }
        }
      }
    },
  })

  useEffect(function checkDeviSource() {
    if (computeSources?.isAuto) {
      setDevisSource('AUTO')
    } else if (computeSources?.isMoto) {
      setDevisSource('MOTO')
    } else if (computeSources?.isIndus) {
      setDevisSource('INDUSTRIE')
    }
  }, [])

  const latestValueRef = useRef(formik.values.message)
  const [initialMessage] = useState(formik.values.message)
  // Envoi de proposition par email
  const handleSubmit = (emailDetails) => {
    setDisableBtn(true)
    // Affichage de la notification de soumission
    const isPartial = pieces.some((p) => {
      return panier.filter((pan) => pan.idCLientDemandePiece === p.id).length < p.quantite
    })

    Swal.fire({
      title: 'Attention',
      html: isPartial
        ? '<span style="color: red;" class="fw-bold"> Vous êtes sur le point d’envoyer une proposition partielle </span><br><br>Merci de confirmer la soumission'
        : 'Merci de confirmer la soumission',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToastMailSend = toast.loading('Envoi des propositions en cours...')
        postEmailPropos(
          aProposerPanier,
          clientId,
          demandeId,
          isPartial,
          emailDetails,
          libelleList,
          devisSource,
          commentaireInterne,
          associations,
          retraitDepot,
          pieceJointeSuppl,
          isAdresseUpdated ? updateAdresseLivraison : [],
          isAdresseUpdated ? updateAdresseFacturation : []
        ).then((res) => {
          const isSent = res?.data?.arrPieceChecked?.filter((a) => a.isAvailable).length > 0
          if (isSent) {
            toast.update(idToastMailSend, {
              render: 'Envoi des propositions terminé avec succès',
              type: 'success',
              isLoading: false,
              autoClose: 3000,
            })
            if (redirectDemandeListPage) {
              navigate(`/demandes/liste`, {
                state: {
                  redirectToClientDemande: redirectToClientDemande,
                  filters: filters,
                },
              })
            } else {
              navigate(`/demandes/${clientId}/traitement/${demandeId}`, {
                state: {
                  redirectToClientDemande: redirectToClientDemande,
                  filters: filters,
                },
              })
            }
            if (res?.status === 200 && res.data !== undefined) {
              if (setDemandeClient) {
                setDemandeClient(res.data.demandePiece[0]?.demande)
                setCommentaireInterne(res.data.demandePiece[0]?.demande?.commentaire ?? '')
              }
              let newPanier: any = [...panier]
              newPanier = newPanier.map((item) => {
                const nomDepot = associations[item?.idPiecePropose]?.depot ?? null // nom du retrait depot
                const depotId = associations[item?.idPiecePropose]?.depotId ?? null // id du retrait depot

                if (item.statut === 'A_PROPO') {
                  // On récupère la pièce correspondante dans res.data
                  const updatedPiece = res.data.demandePiece.find((p) => p.id === item.id)
                  const heureDisponibilite =
                    res.data?.demandePiece.typePiece?.referencementTypePieces?.[0]
                      ?.dureeDisponibilite
                  return {
                    ...item,
                    statut: 'PROPO',
                    //pieceQuantity: pieceQuantity ,
                    isProposed: true,
                    dateProposition: updatedPiece?.dateProposition || new Date().toISOString(),
                    heureDisponibilite: heureDisponibilite ? heureDisponibilite : 24,
                    idRetraitDepot: depotId,
                    nomRetraitDepot: nomDepot,
                  }
                }
                // return item
                return {
                  ...item,
                  idRetraitDepot: depotId,
                  nomRetraitDepot: nomDepot,
                }
              })
              setPanier(newPanier)

              const copieInitiale = newPanier
                .filter((p) => p.statut === 'PROPO')
                .map((p) => {
                  return {
                    id: p.id,
                    tauxRemise: Number(p?.tauxRemise ?? 0),
                    montantRemise: Number(p?.montantRemise ?? 0),
                    fraisDePort: Number(p.fraisDePort ?? 0),
                    fraisDePortInitial: Number(p.fraisDePort ?? 0),
                    prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                    prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                    prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                    prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
                  }
                })
              setInitialPieces(copieInitiale)

              setDisableBtn(false)
              const data = res.data?.demandePiece.map((item) => ({...item, stock: 'chargement'}))
              if (setPiecesProps) {
                setPiecesProps(data)
                setLoadStock(true)
              }
              setOpenModalDevis(false)

              // Re définition de setLibelleChanged sur false si celui-ci était true
              if (setHasLibelleChanged) setHasLibelleChanged(false)

              // Màj des adresses hors ShopModal
              setUpdatedAdresseFactInfo(updateAdresseFacturation)
              setUpdatedAdresseLivInfo(updateAdresseLivraison)
            }
          } else {
            toast.update(idToastMailSend, {
              render: 'Proposition(s) non envoyée(s)',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
            res?.data?.arrPieceChecked?.map((a) => {
              if (a.isAvailable === false) {
                toast.warning(
                  `Proposition de ${a.nomTypePiece} du véhicule ${a.immat} non envoyée`,
                  {
                    autoClose: 3000,
                  }
                )
              }
            })
          }
        })
      }
    })
  }

  // Renvoie de proposition
  const handleRenvoiPropositionSubmit = (emailDetails) => {
    setDisableBtn(false)
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la soumission',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        setLoadingRenvoiPropos(true)
        const idToastMailSend = toast.loading('Renvoi des propositions en cours...')
        const prepareData = (data) => {
          return data?.map((item) => {
            if (item.immat === '') return {...item, immat: `${item?.marque} - ${item?.modele}`}
            return item
          })
        }
        postEmailRenvoiPropos(
          prepareData(piecesProposeesModifiees),
          prepareData(piecesProposeesChecked),
          prepareData(filterPieceAproposee),
          prepareData(filterPieceProposee),
          clientId,
          demandeId,
          emailDetails,
          aProposerPanier,
          libelleList,
          devisSource,
          commentaireInterne,
          associations,
          retraitDepot,
          pieceJointeSuppl,
          isAdresseUpdated ? updateAdresseLivraison : [],
          isAdresseUpdated ? updateAdresseFacturation : []
        ).then((res) => {
          if (res?.status === 200 && res.data) {
            setLoadingRenvoiPropos(false)
            toast.update(idToastMailSend, {
              render: 'Envoi des propositions terminé avec succès',
              type: 'success',
              isLoading: false,
              autoClose: 3000,
            })
            if (setDemandeClient) {
              setDemandeClient(res.data.demandePiece[0]?.demande)
              setCommentaireInterne(res.data.demandePiece[0]?.demande?.commentaire ?? '')
            }
            const updatedPanier = panier.map((piece) => {
              const updatedDemandePiece = res.data.demandePiece.find((p) => p.id === piece.id)

              const nomDepot = associations[piece?.idPiecePropose]?.depot ?? null // nom du retrait depot
              const depotId = associations[piece?.idPiecePropose]?.depotId ?? null // id du retrait depot

              const heureDisponibilite =
                res.data?.demandePiece.typePiece?.referencementTypePieces?.[0]?.dureeDisponibilite
              if (updatedDemandePiece && piece.statut === 'PROPO') {
                return {
                  ...piece,
                  ...updatedDemandePiece,
                  statut: 'PROPO',
                  isProposed: true,
                  idRetraitDepot: depotId,
                  nomRetraitDepot: nomDepot,
                }
              }
              if (piece?.statut === 'A_PROPO') {
                return {
                  ...piece,
                  statut: 'PROPO',
                  isProposed: true,
                  dateProposition: updatedDemandePiece?.dateProposition || new Date().toISOString(),
                  heureDisponibilite: heureDisponibilite ? heureDisponibilite : 24,
                  idRetraitDepot: depotId,
                  nomRetraitDepot: nomDepot,
                }
              }

              // return piece
              return {
                ...piece,
                idRetraitDepot: depotId,
                nomRetraitDepot: nomDepot,
              }
            })
            setPanier(updatedPanier)

            const copieInitiale = updatedPanier
              .filter((p) => p.statut === 'PROPO')
              .map((p) => {
                return {
                  id: p.id,
                  tauxRemise: Number(p?.tauxRemise ?? 0),
                  montantRemise: Number(p?.montantRemise ?? 0),
                  fraisDePort: Number(p.fraisDePort ?? 0),
                  fraisDePortInitial: Number(p.fraisDePort ?? 0),
                  prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                  prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                  prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                  prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
                }
              })
            setInitialPieces(copieInitiale)

            const data = res.data.demandePiece.map((item) => ({...item, stock: 'chargement'}))
            if (setPiecesProps) {
              setPiecesProps(data)
              setLoadStock(true)
            }

            setPiecesProposesModifiees([])
            setCheckedPieces([])
            setPiecesProposeesChecked([])
            setDisableBtn(false)
            // Màj des adresses hors ShopModal
            setUpdatedAdresseFactInfo(updateAdresseFacturation)
            setUpdatedAdresseLivInfo(updateAdresseLivraison)


            // Re définition de setLibelleChanged sur false si celui-ci était true
            if (setHasLibelleChanged) setHasLibelleChanged(false)

            // Rediriger vers la page traitement de demande si dans la page liste piece en stock
            if (onListePieceStockPage) {
              navigate(`/demandes/${clientId}/traitement/${demandeId}`, {
                state: {
                  redirectToClientDemande: redirectToClientDemande,
                  filters: filters,
                },
              })
            }
          } else {
            setLoadingRenvoiPropos(false)
            toast.update(idToastMailSend, {
              render: 'Proposition(s) non envoyée(s)',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
          }
        })
      }
    })
  }

  const showInterventionPopup = () => {
    Swal.fire({
      title: 'Attention - Une intervention est en cours',
      html: '<p>Veuillez réaliser les actions concernées pour pouvoir envoyer le devis.</p>',
      icon: 'warning',
      confirmButtonText: 'OK',
      showCancelButton: false,
      confirmButtonColor: '#1BC5BD',
    })
  }

  // Renvoi de l'email dans l'historique
  const handleRenvoiDevis = (emailDetails) => {
    const idToastMailSend = toast.loading('Renvoi des anciennes propositions en cours...')
    postResendDevis(clientId, demandeDevisId, emailDetails)
      .then((res) => {
        if (res?.status === 200 && res?.data !== undefined) {
          toast.update(idToastMailSend, {
            render: 'Renvoi des anciennes propositions terminé avec succès',
            type: 'success',
            isLoading: false,
            autoClose: 3000,
          })
        }
      })
      .catch(() => {
        console.error('erreur')
        toast.update(idToastMailSend, {
          render: 'Ancienne(s) proposition(s) non renvoyée(s)',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      })
  }

  // Block qui insère automatiquement le lien de proposition de pièce
  // Debut
  const quillRef = useRef<ReactQuill | null>(null)

  useEffect(() => {
    if (!demandeId || !quillRef.current) return

    let handleKeyDown: ((e: KeyboardEvent) => void) | null = null
    let textChangeHandler: ((delta: any, oldDelta: any, source: string) => void) | null = null

    const checkEditorReady = () => {
      const editor = quillRef.current?.getEditor()
      if (!editor) {
        setTimeout(checkEditorReady, 100)
        return
      }

      // console.log('Éditeur prêt, configuration blot...');

      // Définir le blot
      const Quill = (ReactQuill as any).Quill
      const BlockEmbed = Quill.import('blots/block/embed')

      class LienDevisBlot extends BlockEmbed {
        static blotName = 'lienDevis'
        static tagName = 'div'

        static create(value: {url: string | null}) {
          const node = super.create() as HTMLElement
          node.setAttribute('contenteditable', 'false')
          node.setAttribute('data-lien-devis', 'true')
          node.className = 'text-center quill-lien-devis'
          node.innerHTML = displayHistory
            ? `<a href="${url}" target="_blank" class="btn btn-sm btn-primary text-decoration-none">Visualiser votre devis ici</a>`
            : `<button type="button" class="btn btn-sm btn-primary text-decoration-none">Visualiser votre devis ici</button>`
          return node
        }

        static value(node: HTMLElement) {
          return {url: node.querySelector('a')?.getAttribute('href') ?? ''}
        }
      }

      Quill.register(LienDevisBlot)

      // Vérifier si le bloc existe déjà
      const contents = editor.getContents()
      const found = contents.ops?.some((op: any) => op.insert?.lienDevis)

      if (!found) {
        // console.log('Insertion du bloc lienDevis');
        const text = editor.getText()
        let insertIndex = text.indexOf('Cordialement')
        if (insertIndex === -1) insertIndex = editor.getLength() - 1

        // Insérer le bloc
        editor.insertText(insertIndex, '\n', 'user')
        editor.insertEmbed(insertIndex + 1, 'lienDevis', {url: null}, 'user')
        editor.insertText(insertIndex + 2, '\n', 'user')
        // editor.insertText(0, '\n', 'user')

        // SYNCHRO avec deep merge pour préserver Formik
        const currentFormikValue = formik.values.message
        const newEditorContent = quillRef?.current?.getEditor().root.innerHTML
        formik.setFieldValue('message', newEditorContent)

        // console.log('Bloc inséré et synchronisé vers Formik');
        editor.setSelection(insertIndex, 0, 'silent')
      } else {
        // console.log('Bloc lienDevis déjà présent');
      }

      // Définir les handlers
      handleKeyDown = (e: KeyboardEvent) => {
        if (e.key !== 'Backspace' && e.key !== 'Delete') return

        const range = editor.getSelection()
        if (!range) return

        const selectionStart = range.index
        const selectionEnd = range.index + range.length

        // Protection bloc lienDevis
        const [leaf] = editor.getLeaf(selectionStart)
        if (
          leaf?.domNode instanceof HTMLElement &&
          leaf.domNode.getAttribute('data-lien-devis') === 'true'
        ) {
          e.preventDefault()
          e.stopPropagation()
          return
        }

        // Protection première ligne
        const firstLine = editor.getLine(0)
        const firstLineBlot = firstLine?.[0]
        const firstLineLength = firstLineBlot?.length?.() ?? 0
        const touchesFirstLine = selectionStart < firstLineLength && selectionEnd > 0

        if (touchesFirstLine) {
          e.preventDefault()
          e.stopPropagation()
          return
        }

        // Protection sélection avec bloc
        if (range.length > 0) {
          const delta = editor.getContents(selectionStart, range.length)
          const selectionHasLienDevis = delta.ops?.some(
            (op: any) => op.insert && op.insert.lienDevis
          )
          if (selectionHasLienDevis) {
            e.preventDefault()
            e.stopPropagation()
            return
          }
        }
      }

      textChangeHandler = (delta: any, oldDelta: any, source: string) => {
        if (source !== 'user') return

        const contents = editor.getContents()
        const found = contents.ops?.some((op: any) => op.insert?.lienDevis)

        if (!found) {
          // console.log('Réinsertion bloc lienDevis (text-change)');
          const length = editor.getLength()
          editor.insertText(length - 1, '\n', 'silent')
          editor.insertEmbed(length, 'lienDevis', {url: null}, 'silent')
          editor.insertText(length + 1, '\n', 'silent')

          // SYNCHRO FORMik aussi ici
          formik.setFieldValue('message', editor.root.innerHTML)
        }
      }

      // Ajouter les listeners
      editor.root.addEventListener('keydown', handleKeyDown)
      editor.on('text-change', textChangeHandler)

      // console.log('Protections et listeners activés');
    }

    checkEditorReady()

    // Cleanup
    return () => {
      const editor = quillRef.current?.getEditor()
      if (editor && handleKeyDown && textChangeHandler) {
        editor.root.removeEventListener('keydown', handleKeyDown)
        editor.off('text-change', textChangeHandler)
      }
    }
  }, [demandeId, formik]) // formik ajouté aux dépendances
  // Fin du block

  // Chargement des pièces jointes par rapport au devis affiché dans l'historique
  useEffect(() => {
    setPieceJointeSuppl(
      (historiqueDevis && displayHistory)
        ? (historiqueDevis?.[activeHistorique]?.pieceJointeSupplementaire ?? [])
        : []
    )
  }, [activeHistorique, displayHistory]);

  // Vérification du destinataire
  const handleBlurDestinataire = () => {
    const emailValue = formik.values.destinataire?.trim()

    const values = emailValue
      .split(';')
      .map(email => email.trim())
      .filter(Boolean)

    onMailContentChange(values?.join(" ; "), 'destinataire')

    if (!emailValue) {
      setDestinataireError(true)
      setErrorMessage('Le destinataire est requis')
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    const isValid = values.every(email => emailRegex.test(email))

    if (!isValid) {
      setDestinataireError(true)
      setErrorMessage('Email non valide')
    } else {
      setDestinataireError(false)
      setErrorMessage('')
    }
  }

  // Vérification du destinataireCc
  const handleBlurDestinataireCc = () => {
    const emailValue  = formik.values.destinataireCc?.trim()

    const values = emailValue
      .split(';')
      .map(email => email.trim())
      .filter(Boolean)

    onMailContentChange(values?.join(" ; "), 'destinataireCc')

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    const isValid = values.every(email => emailRegex.test(email))

    if (!isValid) {
      setDestinataireCcError(true)
      setErrorMessageDestinataireCc('Email non valide')
    } else {
      setDestinataireCcError(false)
      setErrorMessageDestinataireCc('')
    }
  }

  const removeImage = ( id: string) => {
    setPieceJointeSuppl((prev) => prev.filter((image, index) => index !== id))
  }

  return (
    <div
      style={{width: displayHistory ? '25%' : '30%'}}
      className={'border border-muted rounded-1 p-9'}
      id='hide-on-print'
    >
      <div className='mb-10'>
        <div className='d-flex gap-2 align-items-center'>
          <IconMail />
          <span className='mr-2 fs-3'>Envoi par email</span>
        </div>
        <span className='text-muted'>Le devis sera enregistré dans la fiche demande</span>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className='mb-6'>
          <label className='form-label'>Destinataire</label>
          <input
            type='text'
            style={{fontSize: '13px'}}
            className={`form-control ${destinataireError && 'border border-danger is-invalid'}`}
            placeholder='name@example.com'
            {...formik.getFieldProps('destinataire')}
            onBlur={handleBlurDestinataire}
          />
          {destinataireError && <span className={'text-danger'}>{errorMessage}</span>}
        </div>
        <div className='mb-6'>
          <label className='form-label'>CC</label>
          <input
            type='text'
            style={{fontSize: '13px'}}
            className={`form-control ${destinataireCcError && 'border border-danger is-invalid'}`}
            placeholder='email@example.com ; email@example.com'
            {...formik.getFieldProps('destinataireCc')}
            onBlur={handleBlurDestinataireCc}
          />
          {destinataireCcError && (
            <span className={'text-danger'}>{errorMessageDestinataireCc}</span>
          )}
        </div>
        <div className='mb-6'>
          <label className='form-label'>Objet</label>
          <input
            type='text'
            style={{fontSize: '13px'}}
            className='form-control'
            placeholder='Devis...'
            {...formik.getFieldProps('objet')}
            onBlur={(e) => onMailContentChange(e.target.value, 'objet')}
          />
        </div>
        <div className='mb-6'>
          <label className='form-label'>Message</label>
          <ReactQuill
            key={demandeKey}
            ref={quillRef}
            theme='snow'
            value={formik.values.message}
            onChange={(value) => {
              formik.setFieldValue('message', value)
              latestValueRef.current = value
            }}
            modules={{toolbar: false}}
            onBlur={() => {
              onMailContentChange(latestValueRef.current, 'message')
            }}
          />
        </div>

        {/* debut pièce jointe pdf */}
        <div
          className={
            'd-flex flex-column p-9 border border-muted rounded-2 my-6 bg-light-info border-info'
          }
        >
          <span className={'text-gray-700 mb-3'}>Pièce jointe</span>
          <div className='d-flex align-items-center gap-2 mb-3'>
            {loadingPJ ? (
              <div className='text-info'>
                Chargement de la pièce jointe en cours ...
                <span
                  className='spinner-border spinner-border-sm align-middle ms-2'
                  role='status'
                  aria-hidden='true'
                ></span>
              </div>
            ) : (
              <>
                <div className='mx-2'>
                  <div
                    className='d-flex align-items-center justify-content-center rounded-1 bg-white'
                    style={{
                      width: '35px',
                      height: '35px',
                      flexShrink: 0,
                    }}
                  >
                    <IconDevis size={22} color='#009ef7' />
                  </div>
                </div>
                <div className={nomFichier ? 'text-info' : 'text-danger'}>
                  {nomFichier ? nomFichier : 'PJ non trouvée'}
                </div>
              </>
            )}
          </div>

          {/*{(imagesPOT?.length > 0) && <span className='text-gray-700 mb-3'>Pièce jointe image POT</span>}*/}

          {imagesPOT?.length > 0 && (
            <div className=''>
              {imagesPOT.map((image, index) => (
                <div
                  className='d-flex align-items-center gap-2 mt-1 text-info'
                  key={`${image}-${index}`}
                >
                  <img
                    src={`${pot_url}${image}`}
                    alt={image}
                    className='image-thumbnail rounded-1'
                    width='50'
                    height='50'
                  />
                  <button
                    type='button'
                    onClick={() => handleDownloadPdf(image, false)}
                    style={{
                      cursor: 'pointer',
                      color: '#009ef7',
                      textDecoration: 'none',
                      border: 'none',
                      background: 'none',
                      padding: 0,
                      textAlign: 'left',
                    }}
                  >
                    {image}
                  </button>
                </div>
              ))}
            </div>
          )}

          {pieceJointeSuppl?.length > 0 && (
            <span className='text-gray-700 mb-3 mt-3'>Pièce jointe supplémentaire</span>
          )}

          {/* pieceJointeSuppl peut être un tableau de File ou un tableau de chaine de caractère */}
          {pieceJointeSuppl?.length > 0 &&
            pieceJointeSuppl.map((item: any, key) => (
              <div key={key} className='d-flex align-items-center gap-2 mt-1 text-info'>
                <div style={{position: 'relative'}}>
                  {['.png', '.jpg', '.jpeg','webp'].some((ext) => (item?.name ?? item)?.includes(ext)) ? (
                    <>
                      <img
                        src={`${
                          item?.name
                            ? URL.createObjectURL(item)
                            : `${piece_jointe_supplementaire_url}${item}`
                        }`}
                        alt={item?.name ?? item}
                        className='image-thumbnail rounded-1'
                        width='50'
                        height='50'
                      />
                    </>
                  ) : (
                    <div className='m-2'>
                      <div
                        className='d-flex align-items-center justify-content-center rounded-1 bg-white'
                        style={{
                          width: '35px',
                          height: '35px',
                          flexShrink: 0,
                        }}
                      >
                        <IconDevis size={22} color='#009ef7' />
                      </div>
                    </div>
                  )}
                  {/* Bouton supprimer une pièce jointe */}
                  {!displayHistory && (
                  <button
                    type='button'
                    style={{
                      position: 'absolute',
                      top: '3px',
                      right: '3px',
                      background: 'rgba(0, 0, 0, 0.7)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '50%',
                      width: '15px',
                      height: '15px',
                      cursor: 'pointer',
                      fontSize: '11px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backdropFilter: 'blur(4px)',
                    }}
                    title='Supprimer'
                    onClick={() => removeImage(key)}
                  >
                    ✕
                  </button>)}
                </div>
                <div>
                  <span>{item?.name ?? item}</span>
                </div>
              </div>
            ))}

          {!displayHistory && (
            <span
              className='text-primary cursor-pointer mt-4'
              onClick={() => pieceJointeRef?.current?.click()}
            >
              <input
                type='file'
                multiple
                className='d-none'
                onChange={(event) => {
                  const files = Array.from(event.target.files ?? [])
                  setPieceJointeSuppl((prev) => [...prev, ...files])
                }}
                ref={pieceJointeRef}
              />
              Ajouter une pièce jointe
            </span>
          )}
        </div>
        {/* debut pièce jointe pdf */}

        <div className={'d-flex justify-content-end gap-2'}>
          {nomFichier === false && (
            <button
              type='button'
              className={`btn btn-primary`}
              disabled={loadingPJ}
              onClick={() => regenerateDevisPdf()}
            >
              <span className={'mx-2'}>Recréer le fichier</span>
            </button>
          )}

          <button
            type={haveIntervention ? 'button' : 'submit'}
            disabled={nomFichier === false}
            className={`btn btn-primary ${(destinataireError || loadingPJ) && 'disabled'}`}
            onClick={() => (haveIntervention ? showInterventionPopup() : null)}
            data-bs-dismiss='modal'
          >
            <IconSendMail />
            <span className={'mx-2'}>{`${displayHistory ? 'Renvoyer' : 'Envoyer'} le devis`}</span>
          </button>
        </div>
      </form>
    </div>
  )
}

export default EmailForm
